import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavHeaderComponent } from './shared/components/nav-header/nav-header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
declare let gtag: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, NavHeaderComponent, FooterComponent],
})
export class AppComponent {
  constructor(private router: Router) {
    const navEnd = this.router.events.pipe(filter((event) => event instanceof NavigationEnd));

    navEnd.subscribe((event: NavigationEnd) => {
      this.handleAnalytics(event);
    });
  }

  handleAnalytics(event: NavigationEnd): void {
    if (typeof window !== 'undefined') {
      gtag('config', 'G-9N7Q809R5T', {
        page_path: event.urlAfterRedirects,
      });
    }
  }
}
